import { render, staticRenderFns } from "./CancelUser.vue?vue&type=template&id=1ccd7380&scoped=true&lang=pug&"
import script from "./CancelUser.vue?vue&type=script&lang=js&"
export * from "./CancelUser.vue?vue&type=script&lang=js&"
import style0 from "./CancelUser.vue?vue&type=style&index=0&id=1ccd7380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd7380",
  null
  
)

export default component.exports